import React, { Component, useEffect, useState } from 'react';
import styled from "styled-components";
import { connect } from "react-redux";
import { FormContainer, FormFieldRow, FormFieldColumn, FormSection, FormField, FormInputFull, FormInput, FormTextArea, FormLabel, FormSubHeading, FormItalicHeading, FormSectionPadding } from '../../../../styles/form-styles.js';
import ABButton from '../../../../components/ABButton.js';
import DatePicker from 'react-datepicker';
import colors from '../../../../styles/colors.js';
import ABSelect from '../../../../components/ABSelect.js';
import { EmailStatsTypes } from '../stats-types.js';
import { createStatsEmail, getEmailStat, updateEmailStat } from '../../../../actions/portal/stats-email.js';
import { ToastContainer, toast } from 'react-toastify';
import { history } from '../../../../routers/AppRouter.js';
import ABInputField from '../../../../components/ABInputField';
import { getAlertItems } from '../../../../actions/alert/alert-items.js';
import { AlertItem } from '../../alerts/alert-types.js';
import ABFormButton from '../../../../components/ABFormButton.js';
import { useParams } from 'react-router-dom';

const PageWrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const PageHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
`;

const PageTitle = styled.div`
  color: ${colors.blue};
  font-size: 30px;
  padding: 30px 0 10px 0;
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  div:first-child {
    padding-right: 10px;
  }
`;

const FooterButtons = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const TextButton = styled.div`
    cursor: pointer;
    margin-right: 5px;
    color: ${colors.blue};
`;

const DatePickerStyle = styled.div`
  input {
    padding: 10px;
    font-size: 16px;
    width: 100%;
    min-width: 400px;
    margin-bottom: 20px;
    line-height: 25px;
  }
`;

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledHeading = styled.div`
  padding: 10px 10px 10px 0;
  font-size: 40px;
`;

const StyledSelect = styled.select`
  font-size: 16px;
  padding: 9px 10px 10px 10px;
  width: 450px;
  border: 1px solid ${colors.lightGray};
`;

interface EmailStatsProps {
    createStatsEmail: (statsEmail: EmailStatsTypes) => void;
    updateEmailStat: (statsEmail: EmailStatsTypes, emailStatId: string) => void;
    success?: string | null;
    error?: string | null;
    getAlerts: () => void;
    alerts: AlertItem[];
    getEmailStat: (emailStatId: string) => void;
    emailStat: EmailStatsTypes;

}

interface RouteParams {
    emailStatId: string;
}

function EmailStatsForm({ createStatsEmail, success, error, getAlerts, alerts, getEmailStat, emailStat, updateEmailStat }: EmailStatsProps) {
    const { emailStatId } = useParams<RouteParams>();

    const [alertItemId, setAlertItemId] = useState('');
    const [sent, setSent] = useState('');
    const [newsletterLink, setNewsletterLink] = useState('');
    const [delivered, setDelivered] = useState('');
    const [bounceRate, setBounceRate] = useState('');
    const [openRate, setOpenRate] = useState('');
    const [opens, setOpens] = useState('');
    const [clicks, setClicks] = useState('');
    const [ctr, setCtr] = useState('');
    const [ctor, setCtor] = useState('');
    const [deliveryRate, setDeliveryRate] = useState('');
    const [unsubscribeRate, setUnsubscribeRate] = useState('');
    const [spamRate, setSpamRate] = useState('');
    const [growthRate, setGrowthRate] = useState('');

    useEffect(() => {
        if (success) {
            if (!emailStatId) {
                toast.success("Email stat created successfully!");
                history.push('./');
            } else {
                toast.success("Email stat updated successfully!");
                history.push('../');
            }
        }
        if (error) {
            toast.error('Error Creating Stat');
        }
    }, [success, error]);

    useEffect(() => {
        getAlerts();
    }, [])

    // editing
    useEffect(() => {
        if (emailStatId) {
            getEmailStat(emailStatId);
        } else {
            clearForm();
        }
    }, [emailStatId]);

    // editing
    useEffect(() => {
        if (emailStat && emailStatId && Object.keys(emailStat).length !== 0) {
            setAlertItemId(emailStat.alertItemId?.toString() || '');
            setSent(emailStat.sent?.toString() || '');
            setNewsletterLink(emailStat.newsletterLink?.toString() || '');
            setDelivered(emailStat.delivered?.toString() || '');
            setBounceRate(emailStat.bounceRate?.toString() || '');
            setOpenRate(emailStat.openRate?.toString() || '');
            setOpens(emailStat.opens?.toString() || '');
            setClicks(emailStat.clicks?.toString() || '');
            setCtr(emailStat.ctr?.toString() || '');
            setCtor(emailStat.ctor?.toString() || '');
            setDeliveryRate(emailStat.deliveryRate?.toString() || '');
            setUnsubscribeRate(emailStat.unsubscribeRate?.toString() || '');
            setSpamRate(emailStat.spamRate?.toString() || '');
            setGrowthRate(emailStat.growthRate?.toString() || '');
        }
    }, [emailStat]);

    const clearForm = () => {
        setAlertItemId('');
        setSent('');
        setNewsletterLink('');
        setDelivered('');
        setBounceRate('');
        setOpenRate('');
        setOpens('');
        setClicks('');
        setCtr('');
        setCtor('');
        setDeliveryRate('');
        setUnsubscribeRate('');
        setSpamRate('');
        setGrowthRate('');
    };

    const onCreate = () => {

        if (alertItemId && sent && delivered && openRate && opens && clicks && ctr && ctor && bounceRate && newsletterLink) {

            const emailStats: EmailStatsTypes = {
                alertItemId: parseInt(alertItemId, 10) || 0,
                sent: parseInt(sent, 10) || 0,
                newsletterLink,
                delivered: parseInt(delivered, 10) || 0,
                openRate: parseFloat(openRate) || 0,
                opens: parseInt(opens, 10) || 0,
                clicks: parseInt(clicks, 10) || 0,
                ctr: parseFloat(ctr) || 0,
                ctor: parseFloat(ctor) || 0,
                bounceRate: parseFloat(bounceRate) || 0,
                deliveryRate: deliveryRate ? parseFloat(deliveryRate) : undefined,
                unsubscribeRate: unsubscribeRate ? parseFloat(unsubscribeRate) : undefined,
                spamRate: spamRate ? parseFloat(spamRate) : undefined,
                growthRate: growthRate ? parseFloat(growthRate) : undefined, // Set as undefined if empty
            };
            if (emailStatId) { // editing
                updateEmailStat(emailStats, emailStatId);
            } else {
                createStatsEmail(emailStats);
            }
        } else {
            toast.error('Please fill out all fields.');
        }
    };

    const onCancel = () => {
        clearForm();
        if (!emailStatId) {
            history.push('./');
        } else {
            history.push(`../email-issue-details/${emailStatId}`);
        }
    }

    // const handleDateChange = (date: Date | null) => {
    //     date!.setHours(1);
    //     date!.setMinutes(0);
    //     date!.setSeconds(0);
    //     setDate(date);
    // };

    const handleInputChange = (setter: React.Dispatch<React.SetStateAction<string>>) =>
        (e: React.ChangeEvent<HTMLInputElement>) => setter(e.currentTarget.value);

    const handleSelectChange =
        (setter: React.Dispatch<React.SetStateAction<string>>) =>
            (e: React.ChangeEvent<HTMLSelectElement>) =>
                setter(e.target.value);

    return (
        <PageWrapper>
            <HeadingContainer>
                <StyledHeading>Create Email Stats</StyledHeading>
            </HeadingContainer>

            <FormSubHeading>Alert Id:</FormSubHeading>
            {
                alerts && alerts.length > 0 &&
                <StyledSelect
                    name="alertItemId"
                    value={alertItemId}
                    onChange={handleSelectChange(setAlertItemId)}
                    placeholder="Enter Alert ID"
                >
                    <option value="">Select</option>
                    {alerts.map((item) => (
                        <option key={item.id} value={item.id}>
                            {item.issue} - {item.title}
                        </option>
                    ))}
                </StyledSelect>
            }

            <FormSubHeading>Newsletter Link:</FormSubHeading>
            <ABInputField
                value={newsletterLink}
                onChange={handleInputChange(setNewsletterLink)}
                placeholder="https://..."
            />
            <FormSubHeading>Sent:</FormSubHeading>
            <ABInputField
                value={sent}
                onChange={handleInputChange(setSent)}
                placeholder="Sent"
            />
            <FormSubHeading>Delivered:</FormSubHeading>
            <ABInputField
                value={delivered}
                onChange={handleInputChange(setDelivered)}
                placeholder="Delivered"
            />
            <FormSubHeading>Bounce Rate:</FormSubHeading>
            <ABInputField
                value={bounceRate}
                onChange={handleInputChange(setBounceRate)}
                placeholder="Bounce Rate"
            />
            <FormSubHeading>Open Rate:</FormSubHeading>
            <ABInputField
                value={openRate}
                onChange={handleInputChange(setOpenRate)}
                placeholder="Open Rate"
            />
            <FormSubHeading>Opens:</FormSubHeading>
            <ABInputField
                value={opens}
                onChange={handleInputChange(setOpens)}
                placeholder="Opens"
            />
            <FormSubHeading>CTR:</FormSubHeading>
            <ABInputField
                value={ctr}
                onChange={handleInputChange(setCtr)}
                placeholder="CTR"
            />
            <FormSubHeading>Clicks:</FormSubHeading>
            <ABInputField
                value={clicks}
                onChange={handleInputChange(setClicks)}
                placeholder="Clicks"
            />
            <FormSubHeading>CTOR:</FormSubHeading>
            <ABInputField
                value={ctor}
                onChange={handleInputChange(setCtor)}
                placeholder="CTOR"
            />
            {/* <FormSubHeading>Delivery Rate:</FormSubHeading>
            <ABInputField
                value={deliveryRate}
                onChange={handleInputChange(setDeliveryRate)}
                placeholder="Delivery Rate"
            />
            <FormSubHeading>Unsubscribe Rate:</FormSubHeading>
            <ABInputField
                value={unsubscribeRate}
                onChange={handleInputChange(setUnsubscribeRate)}
                placeholder="Unsubscribe Rate"
            />
            <FormSubHeading>Spam Rate:</FormSubHeading>
            <ABInputField
                value={spamRate}
                onChange={handleInputChange(setSpamRate)}
                placeholder="Spam Rate"
            />
            <FormSubHeading>Growth Rate:</FormSubHeading>
            <ABInputField
                value={growthRate}
                onChange={handleInputChange(setGrowthRate)}
                placeholder="Growth Rate"
            /> */}

            <ActionButtons>
                <FooterButtons>
                    <ABButton
                        title={emailStatId ? "Update Stat" : "Create Stat"}
                        onClick={onCreate}
                    />
                    <TextButton title="cancel" onClick={onCancel}>Cancel</TextButton>
                </FooterButtons>
            </ActionButtons>
            <ToastContainer />
        </PageWrapper>
    );
};

const mapStateToProps = (state: any) => {
    return {
        error: state.statsEmail.error,
        success: state.statsEmail.success,
        alerts: state.alertItems.data,
        emailStat: state.statsEmail.emailStat
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    createStatsEmail: (queryParams?: object) => dispatch(createStatsEmail(queryParams)),
    updateEmailStat: (queryParams: object, emailStatId: string) => dispatch(updateEmailStat(queryParams, emailStatId)),
    getEmailStat: (emailStatId: string) => dispatch(getEmailStat(emailStatId)),
    getAlerts: (queryParams?: object) => dispatch(getAlertItems(queryParams))
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailStatsForm);